import dynamic from 'next/dynamic';

import { Modal } from '~components/Modals/Base';

const Content = dynamic(
	() => import('./dynamicContent').then((mod) => mod.DynamicContent),
	{
		ssr: false,
	}
);

export const ResetMemoryModal = ({
	open,
	onClose,
}: {
	open: boolean;
	onClose: () => void;
}) => {
	return (
		<Modal locked open={open} onClose={onClose}>
			{open && <Content onClose={onClose} />}
		</Modal>
	);
};
